import React, { useState, useEffect } from "react";
import FilterableProducts from "../../components/search/FilterableProducts";
import { useRequest } from "../../hooks/useRequest";
import styled from "styled-components";
import Button from "../../components/common/Button";
import SlidingBanner from "../../components/common/SlidingBanner";
import TrendingProductsGrid from "../../components/common/TrendingProductsGrid";
import { Skeleton } from "@mui/material";
import { useAppContext } from "../../context/useAppContext";
import SEO from "../../components/seo/SEO";

const ClearanceStyle = styled.div`
  padding: 60px 0;
  .blogs__banner {
    margin: 0 0 60px;
    height: 200px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .page__title {
      color: #fff;
      font-size: 32px;
      font-weight: 700;
      line-height: 51px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 82.5px;
      display: flex;
      flex-direction: column;
      align-items: baseline;
      row-gap: 10px;
    }
  }
`;

const Clearance = () => {
  const [fetchBrands] = useRequest();
  const { categoriesTree: contextCategories, categoriesLoading } = useAppContext();
  const [brandsData, setBrandsData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (!brandsData?.length) {
        const brandData = await fetchBrands({
          path: `/brand?limit=100&page=1`,
        });
        setBrandsData(brandData?.data?.docs);
      }
    };

    fetchData();
  }, [brandsData]);

  const [
    fetchSlidingBanner,
    { isLoading: isFetchingSlidingBanner, state: slidingBanners },
  ] = useRequest(`/clearanceslider?limit=10&page=1`);

  useEffect(() => {
    fetchSlidingBanner();
  }, []);

  return (
    <ClearanceStyle>
      <SEO
        title="Clearance Building Materials - Discounted Construction Supplies | Instabuild"
        description="Shop clearance building materials and construction supplies at discounted prices. Find great deals on roofing, lumber, tools, insulation, drywall, and more. Limited stock available."
        keywords="clearance building materials, discounted construction supplies, clearance construction products, sale building materials, discounted building supplies, clearance construction tools"
      />
      <div className="container">
        {/* <div className="blogs__banner">
          <img src="/images/blogs.jpg" alt="blogs" />
          <div className="page__title">
            Group Buy
            <Button title={"Shop Page"}></Button>
          </div>
        </div> */}
        <SlidingBanner
          reqHeight={180}
          onlyBanner={true}
          bannerData={slidingBanners?.data?.docs}
          leftdistance={30}
          loading={isFetchingSlidingBanner || !slidingBanners?.data?.docs}
        />
        <div style={{ marginBottom: 50 }}></div>
        {/* {categoriesLoading ? (
          <Skeleton variant="rectangular" width={"100%"} height={400} style={{ marginBottom: "50px" }} />
        ) : ( */}
          <FilterableProducts
              categoriesData={contextCategories}
            brandsData={brandsData}
            title="Clearance Products"
            type="clearance"
          />
        {/* )} */}
      </div>
      <div className="container">
        <TrendingProductsGrid heading={"Top Selling Clearance Products"} api={"/product/top-selling"} />
      </div>
    </ClearanceStyle>
  );
};

export default Clearance;
